import styled from 'styled-components'

type Props = {
	isContentString: boolean
}

export const Container = styled.div<Props>`
	display: flex;
	align-items: center;
	column-gap: 6px;
	margin-left: -3px;
	background-color: transparent;
	min-width: 0;
	font-size: 15px;
	line-height: 1.2;

	/* To support ellipsis for the text content, we have to do it on a child of the flexbox */
	> span {
		margin-top: ${({ isContentString }) => (isContentString ? 0 : '1.35px')};
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	> svg {
		flex-shrink: 0;
		height: 18px;
		width: 18px;
	}
`
